export const STATUS = {
  PENDING: 1,
  PROCESSING: 2,
  FINISHED: 3,
  CLOSE: 4,
};

export const SEO = {
  cn: {
    title: 'Crypto Airdrop | Get free crypto from upcoming airdrops | Binance.com',
    description:
      'With Binance Airdrop, you get free coins from the hottest airdrops. Earn from free cryptocurrency 	airdrops by depositing soon-to-trade tokens on Binance',
  },
  en: {
    title: 'Crypto Airdrop | Get free crypto from upcoming airdrops | Binance.com',
    description:
      'With Binance Airdrop, you get free coins from the hottest airdrops. Earn from free cryptocurrency 	airdrops by depositing soon-to-trade tokens on Binance',
  },
};

export const FAQ = {
  en: {
    useTitle: 'How to Use Binance Airdrop',
    tipsTitle: 'Binance Airdrop Rules and Tips',
    useList: [
      {
        title: 'Step 1: Stay Tuned for News on Upcoming Airdrops',
        text:
          'Binance Airdrop offers exclusive airdrops of cryptocurrencies that are soon to be listed on Binance. Follow Binance announcements and our social media accounts [Telegram, Twitter, Facebook, Instagram, YouTube] for the latest news on upcoming airdrops.',
      },
      {
        title: 'Step 2: Deposit the Featured Crypto on Binance Airdrop ASAP',
        text:
          'Once we announce an upcoming cryptocurrency listing, Binance Airdrop will now allow you to deposit your tokens ahead of trading time. Act fast, because the sooner you deposit, the bigger your reward will be.',
      },
      {
        title: 'Step 3: Get Free Coins from Binance Airdrop',
        text:
          'After the timer runs out or the progress bar fills up, whichever comes first, you will get your free tokens from Binance Airdrop, home to the best free cryptocurrency airdrops in the world.',
      },
    ],
    tipsList: [
      {
        title: 'Early Deposits Get Better Rewards',
        text:
          'The Binance Airdrop progress bar is divided into tiers. The first tier has the biggest airdrop rate, which gets smaller over the next tiers. You would want to get the biggest rate, so check this page often for updates.',
      },
      {
        title: 'First Come, First Served',
        text:
          'The first deposits we receive will get the biggest airdrop rate. It all depends on how soon you deposit after we announce an airdrop. Be alert, and you’ll get a greater chance for a more rewarding airdrop.',
      },
      {
        title: 'Receive Rewards Over 2 Months',
        text:
          'Rewards from this activity will be split into thirds and distributed to participants over 2 months. Users will only receive a third of their rewards earned from this activity prior to the start of trading.',
      },
    ],
  },
  cn: {
    useTitle: '如何获取空投返利。',
    tipsTitle: '参加空投活动的建议',
    useList: [
      {
        title: '步骤1: 随时关注binance空投新闻',
        text:
          '币安针对新上线的币种发起空投返利。敬请关注Binance公告群和我们的社交媒体[Telegram，Twitter，Facebook，Instagram，YouTube]，及时知晓关于空投返利的最新消息。',
      },
      {
        title: '步骤2: 快速充值，获得大额返利',
        text:
          '空投比例将和总体充值量有关,总体充值量越小，空投比列越大。及时关注上币公告，尽早充值，您将有机会获得更多空投。',
      },
      {
        title: '步骤3: 领取您的返利金',
        text: '活动结束后,您将从Binance获取您的返利金。',
      },
    ],
    tipsList: [
      {
        title: '活动开始即刻充值',
        text:
          '活动期间空投比例是根据充总量决定，总体充值量越小，空投比例越大。总体充值量越大，空投比例小。',
      },
      {
        title: '返利金先到先得',
        text: '活动开始，即可快速完成充值，总体充值量越小，空投率越大。您将有机会获得更多的空投。',
      },
      {
        title: '返利金平均分发（2个月）',
        text:
          '活动的奖将会分为三份，我们会在2个月内分发给每个参与者。交易之前用户仅会得到三分之一的返利金。',
      },
    ],
  },
};
